export default __webpack_public_path__ + "static/media/textilesenergy.518d0f8e.webp";